import { Component, computed, inject, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import {
    FunkyButtonComponent,
    GrowInAnimation,
    GrowOutAnimation,
} from '@exl-ng/mulo-common';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { INSTITUTION_CODE } from '../../app.component';
import { CustomTranslatePipe } from '../../shared/pipes/custom-translate.pipe';
import {
    DepositFilesLinksComponent,
    DepositSearchForComponent,
    DepositSelectedResearchComponent,
    DepositTypeComponent,
} from '../deposit-sections';
import { DepositFormSectionComponent } from '../deposit-form-section/deposit-form-section.component';
import { DepositFormDataService } from '../deposit-form-data.service';
import { JwtUtilService } from '../../core/jwt-util.service';
import { ContentDialogService } from '../../parts/dialogs/content-dialog/content-dialog.service';

@Component({
    selector: 'esp-deposit-output-dialog',
    templateUrl: './deposit-output-dialog.component.html',
    styleUrl: './deposit-output-dialog.component.scss',
    animations: [GrowInAnimation, GrowOutAnimation],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatSelectModule,
        FunkyButtonComponent,
        MatIcon,
        TranslateModule,
        CustomTranslatePipe,
        DepositFormSectionComponent,
        DepositSearchForComponent,
        DepositSelectedResearchComponent,
        DepositTypeComponent,
        DepositFilesLinksComponent,
    ],
})
export class DepositOutputDialogComponent {
    readonly isTypeSelected = signal(false);
    readonly selectedResearch = computed(() => this.dataSvc.selectedResearch());
    readonly getSearchForTitle = computed(() =>
        this.selectedResearch()
            ? 'research.identify.title'
            : 'research.search.title',
    );
    readonly getSearchForDescription = computed(() =>
        this.selectedResearch()
            ? 'research.search.selected.asset.subtitle'
            : 'research.search.subtitle',
    );
    userId = inject(JwtUtilService).getUserID();
    private router = inject(Router);
    private institutionCode = inject(INSTITUTION_CODE);
    private dataSvc = inject(DepositFormDataService);
    readonly displaySearchFor = computed(
        () => !this.dataSvc.isReservedOrRegisteredDoi(),
    );
    private contentDialogSvc = inject(ContentDialogService);

    goToDepositPage() {
        this.router
            .navigate(['/deposit/output', this.dataSvc.resourceType], {
                queryParams: { institution: this.institutionCode },
            })
            .then(() => this.contentDialogSvc.closeDialog());
    }

    onTypeSelection(value: string) {
        this.isTypeSelected.set(true);
        const index = value.indexOf('.');
        if (index !== -1) {
            const category = value.substring(0, index);
            if (
                this.dataSvc.category.value &&
                this.dataSvc.category.value !== category
            ) {
                this.clearReservedRegisterDoi();
            }
            this.dataSvc.updateCategory(category);
        }
        this.dataSvc.updateType(value);
    }

    clearReservedRegisterDoi() {
        if (this.dataSvc.isReservedOrRegisteredDoi()) {
            this.dataSvc.updateDoi('');
            this.dataSvc.updateCleanReservedRegisterDoi(true);
            this.dataSvc.updateIsRegisteredDOI(false);
            this.dataSvc.updateIsReservedDOI(false);
            this.dataSvc.updateResearcherReservedDoi(false);
        }
    }

    onResearchSelection(event) {
        this.dataSvc.selectedResearch.set(event);
    }

    onRemoveSelectedWork() {
        this.dataSvc.selectedResearch.set(null);
        this.dataSvc.enableFormEnrichment();
    }
}
